'use client'

import { NostoProductRecommendationsSection } from '../../brunswick/components/NostoProductRecommendationsSection'
import { ErrorPageContents } from '../_components/pages/Error.client'

export default function ShopErrorPage({ error }: { error: Error & { digest?: string } }) {
  return (
    <>
      <ErrorPageContents error={error}>
        <NostoProductRecommendationsSection
          nostoPlacementId='notfound-nosto-2'
          gutterSize='expanded'
        />
        <NostoProductRecommendationsSection
          nostoPlacementId='notfound-nosto-1'
          gutterSize='expanded'
        />
      </ErrorPageContents>
    </>
  )
}
